import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

import Step1 from "./orderSteps/step-1-order-display"
import Step2 from "./orderSteps/step-2-order-validate_price"
import Step3 from "./orderSteps/step-3-order-calc-price.js"
import Step4 from "./orderSteps/step-4-order-charge"
import Step5 from "./orderSteps/step-5-order-create-code"
import Step6 from "./orderSteps/step-6-order-email"
import Step7 from "./trialSteps/step-5"
// import Error from "./trialSteps/error"


const Error = props => {
  let {message, databaseData, machineState } = props;

  switch (machineState) {
    case 1: 
        machineState="Place Order"; break;
    case 2: 
        machineState="Validate Price"; break;
    case 3: 
        machineState="Checkout"; break;
    case 4: 
        machineState="Charge Card"; break;
    case 5: 
        machineState="Create Code"; break;
    case 6: 
        machineState="Sending Email"; break;
    case 7: 
        machineState="Order Placedl"; break;
    default:
        machineState="Unknown State"; break;   
  };

  let subject = `Error placing PatternMaker order `
  let body = `While placing an order the following error was created:\n
  ${JSON.stringify(message)}
  The machine state is ${machineState}
  ${JSON.stringify(databaseData,0,2)}
  `

  return <>
      <h1>{props.message}</h1>

      <h2>Server Error</h2>
      <p>
          To get your trial code 
          &nbsp;
          <a href = {`mailto:support@patternmakerusa.com?subject=${subject}&body=${encodeURIComponent(body)}`}>
              email support
          </a>
          .  The generated email will contain information about your code and debug information so the engineers can fix the issue.
      </p>
    </>
}

const Page = props => {
  const StaticPage = props.data.wordpressPage
  const [machineState, setMachineState] = useState(1);
  const [databaseData, setDatabaseData] = useState({});
  const [error, setError] = useState(false);
  let step = undefined;

  const handleNextStep = () => {
    setError(false);
    setMachineState( machineState+1 );
  }
  const handleDatabaseError = message =>{
    setMachineState(1)
    setError( message );
  } 
  if ( error ) {
    step = <>
      <Error message={error} databaseData={databaseData} machineState={machineState} />
      <Step1 nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    </>
  }
  else {
    let { stripeKey, apiServer } = props.data.site.siteMetadata

    if ( machineState===1 ) step = <Step1 nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===2 ) step = <Step2 serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===3 ) step = <Step3 stripeKey={stripeKey} serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===4 ) step = <Step4 serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===5 ) step = <Step5 serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===6 ) step = <Step6 serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
    if ( machineState===7 ) step = <Step7 serverUrl={apiServer} nextStep={handleNextStep} onError={handleDatabaseError} databaseData={databaseData} setDatabaseData={setDatabaseData} />
  }

  let wp_content =(
    <>
      <h1>{StaticPage.title}</h1>
      <div dangerouslySetInnerHTML={ {__html: StaticPage.content}}></div>
    </>
  )

  return (
    <>
      <Layout pathname={"/cart"}>
        <SEO title="Home" />
          {wp_content}
          {step}
      </Layout>
    </>
  )
}

export default Page

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPage(id: { eq: $id }) {
      title
      content
    }
    site {
      id
      siteMetadata {
        title
        description
        stripeKey
        apiServer
      }
    }

  }
`